<template>
<router-view />
</template>

<script>
export default {
  name: 'Env',
  routeInfo: {
    label: '动环监控',
    icon: 'fa fa-users'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/07Env/index.vue